import React from "react";
import * as Progress from "@radix-ui/react-progress";
import { colors, cornerRadius, styled } from "../../stitches.config";
import { FlexRow } from "./__styles__/Layout";
import { Body } from "./Typography";

export const ProgressBar = ({
  value,
  max,
  showIndicator = true,
}: {
  value: number;
  max: number;
  showIndicator?: boolean;
}) => {
  const finalValue = Math.min(value, max);

  const fillPercent = Math.max(0.5, Math.round((finalValue / max) * 100));
  const displayPercent = Math.round((value / max) * 100);

  return (
    <FlexRow gap="m" style={{ alignItems: "center" }}>
      <ProgressRoot value={finalValue} max={max}>
        <ProgressIndicator
          style={{
            transform: `translateX(-${100 - fillPercent}%)`,
          }}
        />
      </ProgressRoot>
      {showIndicator && (
        <Body size="small" type="emphasis" color="contentInfo">
          {displayPercent}%
        </Body>
      )}
    </FlexRow>
  );
};

//these styles have to be in the same file as the radix dropdown to work:
const ProgressRoot = styled(Progress.Root, {
  position: "relative",
  overflow: "hidden",
  background: colors.bgUiList,
  borderRadius: cornerRadius.radiusSm,
  width: "100%",
  height: "12px",
  /* Fix overflow clipping in Safari */
  /* https://gist.github.com/domske/b66047671c780a238b51c51ffde8d3a0 */
  transform: "translateZ(0)",
});

const ProgressIndicator = styled(Progress.Indicator, {
  backgroundColor: colors.contentInfo,
  width: "100%",
  height: "100%",
  transition: "transform 660ms cubic-bezier(0.65, 0, 0.35, 1)",
});
